import React from 'react'
import { Field, Formik } from 'formik'
import { useDispatch } from 'react-redux'
import { startCase, isEmpty } from 'lodash'
import * as Yup from 'yup'

import { Button } from '@/components/buttons/Button'
import { CHANNEL_TYPE } from '@/utils/constants'
import { closeModal } from '@/reducers/ui/ui.redux'
import { createManualTask } from '@/reducers/tasks/tasks.actions'
import { TextArea, TextField } from '@/components/forms/formik'

const getValidationSchema = () =>
  Yup.object().shape({
    name: Yup.string().required('Name is required'),
    reason: Yup.string().required('Reason is required'),
  })

export const ManualTaskForm = ({
  callId,
  userId,
  organizationId,
  type,
  callType = CHANNEL_TYPE.CALL,
  messageId,
  onClose,
}) => {
  const dispatch = useDispatch()

  // NOTE: If this modal needs to be expanded for a third manual type, PLEASE pass these variables in
  // as props instead of adding more conditionals here. Two is fine, three is not.
  const defaultName =
    type === 'compliance'
      ? `Compliance Task for ${startCase(callType)}: ${callType === CHANNEL_TYPE.CALL ? callId : messageId}`
      : `Coaching Task for ${startCase(callType)}: ${callType === CHANNEL_TYPE.CALL ? callId : messageId}`
  const placeholder =
    type === 'compliance'
      ? `What was the compliance issue?`
      : `What does this agent need coaching on?`
  const buttonLabel = type === 'compliance' ? 'Send to Compliance Inbox' : 'Send to Coaching Inbox'

  const saveEscalation = ({ name, reason }) => {
    const timestamp = 0

    dispatch(createManualTask(callId, userId, organizationId, name, reason, timestamp, type))
    dispatch(closeModal())

    if (onClose) {
      onClose()
    }
  }

  return (
    <Formik
      validateOnMount
      initialValues={{ reason: '', name: defaultName }}
      validationSchema={getValidationSchema()}
      onSubmit={saveEscalation}
    >
      {({ handleSubmit, errors }) => {
        return (
          <form className="field-stack" onSubmit={handleSubmit}>
            <Field name="name" component={TextField} placeholder="Title" label="Task Title" />
            <Field name="reason" component={TextArea} placeholder={placeholder} label="Reason" />

            <div className="modal-footer">
              <Button
                data-testid="cancel-manual-task"
                onClick={() => {
                  dispatch(closeModal())
                }}
              >
                Cancel
              </Button>
              <Button
                data-testid="save-manual-task"
                brand
                type="submit"
                onClick={handleSubmit}
                disabled={!isEmpty(errors)}
              >
                {buttonLabel}
              </Button>
            </div>
          </form>
        )
      }}
    </Formik>
  )
}
